(function () {
  const REVEAL_SELECTOR = '.scroll-reveal:not(.is-visible)';
  const MOBILE_MQ = '(max-width: 749px)';
  const FAILSAFE_MS = 2500;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function revealAll(elements) {
    elements.forEach((el) => el.classList.add('is-visible'));
  }

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight * 0.95 && rect.bottom > 0;
  }

  function initScrollReveal(root = document) {
    const elements = Array.from(root.querySelectorAll(REVEAL_SELECTOR));
    if (elements.length === 0) return;

    // Mobile: skip IntersectionObserver entirely — CSS already forces visible,
    // but mark is-visible so any desktop-only styles stay consistent on resize.
    if (isMobileViewport() || prefersReducedMotion()) {
      revealAll(elements);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -6% 0px',
        threshold: 0.05,
      }
    );

    elements.forEach((element) => {
      if (isInViewport(element)) {
        element.classList.add('is-visible');
        return;
      }
      observer.observe(element);
    });

    // Desktop fail-safe: never leave content permanently hidden if a trigger is missed.
    window.setTimeout(() => {
      const leftover = Array.from(root.querySelectorAll(REVEAL_SELECTOR));
      if (leftover.length) revealAll(leftover);
      observer.disconnect();
    }, FAILSAFE_MS);
  }

  document.addEventListener('DOMContentLoaded', () => initScrollReveal());

  // If the user rotates to mobile mid-session, force-reveal anything still hidden.
  const mobileMq = window.matchMedia(MOBILE_MQ);
  const onViewportChange = () => {
    if (mobileMq.matches) {
      revealAll(document.querySelectorAll(REVEAL_SELECTOR));
    }
  };
  if (typeof mobileMq.addEventListener === 'function') {
    mobileMq.addEventListener('change', onViewportChange);
  } else if (typeof mobileMq.addListener === 'function') {
    mobileMq.addListener(onViewportChange);
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initScrollReveal(event.target));
  }
})();
